// extracted by mini-css-extract-plugin
export var equalColumn = "_dh-0";